module.exports = __webpack_public_path__ + "static/media/download.33c56cef.svg";